import axios from 'axios'
import { MONTHLY_COMMISSIONS_ENDPOINT } from '../../endpoints'

export async function getCommissionsPeriods() {
    try {
        let { data: { data } } = await axios.get(`${MONTHLY_COMMISSIONS_ENDPOINT}/getAllPeriods`);
        data = data.map(period => {
            return {
                label: period?.period_name,
                value: period?.id
            }
        });
        return data;
    } catch (error) {
        console.log(`Error getCommissionsPeriods `, error);
        return [];
    }
}